import axios from 'axios';
import { globalSettings, isUndNullEmp, responseGet } from '../../helpers/settings';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { condominiumBoardRoleModelGet } from '../../models/condominiumBoard/role';

let result;
let dataObj = {};
let headerObj = {};

export const apartMentUserRolesApplicantsGetAsync = async ({ buildingId = '', withDetails = false, auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'apartMentUserRolesApplicantsGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let building = buildingModelGet({});
        let apartmentUsers = [apartmentUserModelGet({})];
        let condominiumBoardRoles = [condominiumBoardRoleModelGet({})];
        //#endregion variables

        //#region user get apartments
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            conditionals: [],
            ordersBy: [],
            buildingId: buildingId,
            //methodName: 'apartmentUsersWithDetailsGetAsync',
            method: globalSettings?.app?.backend?.methods?.apartmentUsersWithDetails,
            withDetails: withDetails,
            languageId: languageId,
            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartmentUsers}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        building = response?.result?.building;
        apartmentUsers = response?.result?.apartmentUsers;
        //#endregion get user apartments

        //#region get condominium board roles
        dataObj = {
            conditionals: [
                { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}`, },
            ],
            ordersBy: [
                { field: globalSettings?.collections?.properties?.hierarchy, value: 'asc', },
            ],
            languageId: languageId,
            buildingId: buildingId,
            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardRoles}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        condominiumBoardRoles = response?.result;
        //#endregion get condominium board roles

        //#region final data set
        response.result = {
            building: building,
            apartmentUsers: apartmentUsers,
            condominiumBoardRoles: condominiumBoardRoles,
        };
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}